<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">菜单添加</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">


                <el-form :model="list" :rules="rules" ref="addForm">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="名称" required prop="name">
                                    <el-input v-model="list.name"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="排序" required prop="sort">
                                    <el-input v-model="list.sort"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                </el-form>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading"  type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'Add',
        props: ["listMenuDTO"],
        data() {
            return {

                loading: false,
                
                list:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    parentAreaCode:'00000000-0000-0000-0000-000000000000',
                    name:'',
                    sort:'',
                },
                rules:{
                    name:[
                        { required: true, message: '请输入菜单名称', trigger: 'blur' },
                    ],
                    sort:[
                        { required: true, message: '请输入排序', trigger: 'blur' },
                    ],
                },

                parentMenuName:'',

            }
        },

        methods: {

            init(parentAreaCode){
                console.log(parentAreaCode)

                this.$refs.addForm.resetFields();
                this.list.parentAreaCode='00000000-0000-0000-0000-000000000000'
                if(parentAreaCode != ""){
                    this.list.parentAreaCode = parentAreaCode;
                }
            },

            closeSelf() {
                this.$emit("closeAdd");
            },

            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if (valid) {
                        this.addSubmit()
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });




            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.list.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Area/Add",
                    data: this.list
                }).then(
                    (response) => {
                        console.log(response);
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$emit("closeAdd");
                        } else {
                            this.$message({type: 'info', message: '添加失败'});
                        }

                    }
                )
            },
        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: auto;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
